import {
  BarChart3,
  Inbox,
  KanbanSquare,
  KeyRound,
  Plug,
  Radio,
  Settings,
  Sparkles,
  Users,
  type LucideIcon,
} from 'lucide-react';

import type { Role } from '../../api/types';

export interface NavItem {
  to: string;
  label: string;
  implemented: boolean;
  icon: LucideIcon;
  /** Roles allowed to see this item; omitted = every role (§M9 RBAC matrix). */
  roles?: readonly Role[];
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/inbox', label: 'Инбокс', implemented: true, icon: Inbox },
  { to: '/contacts', label: 'Контакты', implemented: true, icon: Users },
  { to: '/kanban', label: 'Канбан', implemented: true, icon: KanbanSquare },
  { to: '/channels', label: 'Каналы', implemented: true, icon: Radio },
  { to: '/agents', label: 'Агенты', implemented: true, icon: Sparkles, roles: ['owner', 'lead'] },
  { to: '/extension', label: 'Расширение', implemented: true, icon: Plug },
  { to: '/analytics', label: 'Аналитика', implemented: true, icon: BarChart3 },
  { to: '/settings', label: 'Настройки', implemented: true, icon: Settings, roles: ['owner', 'lead'] },
  { to: '/account', label: 'Мой доступ', implemented: true, icon: KeyRound },
];

export function visibleNavItems(items: NavItem[], role: Role | undefined): NavItem[] {
  return items.filter((item) => !item.roles || (role && item.roles.includes(role)));
}

/** Dev sandbox pages (§5): only visible in local dev or with VITE_DEV_TOOLS=true. */
export const DEV_NAV_ITEMS: NavItem[] = [
  { to: '/dev/vk', label: 'Dev: VK', implemented: true, icon: Radio },
  { to: '/dev/telegram', label: 'Dev: Telegram', implemented: true, icon: Radio },
];

export function isDevToolsEnabled(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === 'true';
}
